import React from 'react';
import { Field } from 'react-final-form';
import { DateRangePickerInput } from '../DateRange';

const DateRangeField = ({ title, name, validate, onChange, showErrorMessage = false, ...restProps }) => (
  <Field
    name={name}
    validate={validate}
    render={({ input, meta }) => (
      <DateRangePickerInput
        title={title}
        {...restProps}
        {...input}
        onChange={(value) => {
          onChange?.(value);
          input.onChange(value);
        }}
        error={(showErrorMessage || meta.touched) && meta.error}
      />
    )}
  />
);

export default DateRangeField;
